const initTabComponent = () => {
    const tabSelectorArray = document.querySelectorAll("[data-tab-selector]");
    if (tabSelectorArray && tabSelectorArray.length > 0) {
        tabSelectorArray.forEach(tabSelector => {
            tabSelector.addEventListener("click", () => {
                //remove class active
                tabSelectorArray.forEach(x => x.classList.remove("active"));
                tabSelector.closest("[data-tabs-container]").querySelectorAll(`[data-tab-content]`).forEach(x => x.classList.remove("active"));
                //add class active
                const index = tabSelector.getAttribute("data-tab-selector");
                tabSelector.classList.add("active");
                tabSelector.closest("[data-tabs-container]").querySelector(`[data-tab-content="${index}"]`).classList.add("active");
            });
        });
    }
};
